import React, { Component, Fragment } from 'react';
import { Button, Popover, PopoverBody } from 'reactstrap';
import api from '../../api/api';
import apiFunctions from "../../api/functions.js"
import Modal from "./Modal";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import Calendar from './Calendar';
import moment from 'moment';

class MiCalendario extends Component {
    constructor() {
        super();
        this.state = {
            events:[],
            evento_id : null,
            fecha_desde: moment().subtract(4, 'months'),
            fecha_hasta: moment().add(6, 'months'),
            usuario_id: null,
            pop_referencias: false,
            referencias: [],
        };
    }

    traerTiposEventos = () => {
        let parameters = {};
        let fields = ['id','nombre','backgroundColor'];
        parameters.fields = fields;
        apiFunctions.get(api.calendar.tipoEventos, null, this.props.depth, parameters, (response) => {
            let event = response.data;
            this.setState({
                referencias: event,
            });
        }
        );
    }

    traerEventos = (fecha_desde, fecha_hasta) => {
        let parameters = {};
        let filters = ['fin[date__gte]='+fecha_desde.format('YYYY-MM-DD'),'comienzo[date__lte]='+fecha_hasta.format('YYYY-MM-DD')];
        parameters.filters = filters;
        apiFunctions.get(api.calendar.eventosUsuario, null, this.props.depth, parameters, (response) => {
            let event = response.data;
            event.map(function(obj){
                let comienzo = new Date(obj.comienzo);
                let fin = new Date(obj.fin);
                obj.titulo = moment(comienzo).format('HH:mm') + ' - '+ obj.titulo;
                obj.comienzo = comienzo;
                obj.resuelta_label = obj.resuelta ? moment(obj.fecha_resuelta).format('DD-MM-YYYY HH:mm') : "NO"
                obj.fin = fin;
                obj.tooltip = obj.titulo;
             });
            this.setState({
                events: event,
            });
        }
        );
    }

    onSubmit = () => {
        const {fecha_desde, fecha_hasta} = this.state;
        this.traerEventos(fecha_desde, fecha_hasta);
    }

    componentDidMount = () => {
        const {fecha_desde, fecha_hasta} = this.state;
        apiFunctions.get(api.usuarios.perfil, null, this.props.depth, null, (response) => {
            let usuario_id = (response.data.id) ? (response.data.id) : (null)
            this.setState({
                usuario_id: usuario_id,
            });
        });

        this.traerEventos(fecha_desde, fecha_hasta);
        this.traerTiposEventos();
    }

    onRangeChange = (e) => {
        const {fecha_desde, fecha_hasta} = this.state;
        let start = moment(e.start);
        let end = moment(e.end);

        if (fecha_desde.isAfter(start.subtract(2, 'months'))){

            this.setState({
                fecha_desde: start.subtract(4, 'month'),
                fecha_hasta: fecha_hasta.subtract(2, 'month')
            });
            this.traerEventos(start.subtract(4, 'month'), fecha_hasta);
        }

        if (fecha_hasta.isBefore(end.add(2, 'months'))){

            this.setState({
                fecha_desde: fecha_desde.add(2, 'month'),
                fecha_hasta: end.add(6, 'month')
            });
            this.traerEventos(fecha_desde, end.add(6, 'month'));
        }

    }

    render() {
        const { events, evento_id, usuario_id, pop_referencias, referencias } = this.state;
        return (
             <div className="ui-calendar-page">
                <div className="ui-calendar-toolbar">
                    <Modal action="CREATE" onSubmit={this.onSubmit} usuario_id={usuario_id}/>
                    <Button
                        className="ui-calendar-action-button"
                        id="Popover1"
                        onClick={()=>{this.setState({pop_referencias:!pop_referencias})}}
                    >
                        Referencias
                    </Button>
                    <Popover placement="bottom" isOpen={pop_referencias} target="Popover1" toggle={()=>{this.setState({pop_referencias:!pop_referencias})}}>
                        <PopoverBody className="ui-calendar-reference-popover">
                            {
                                referencias.map((e, i)=>(
                                    <div key={i} className="ui-calendar-reference-row">
                                        <span>{e.nombre}</span>
                                        <span
                                            className="ui-calendar-reference-color"
                                            style={{ background: `#${e.backgroundColor}` }}
                                        />
                                    </div>
                                ))
                            }
                        </PopoverBody>
                    </Popover>
                </div>

                <div className="ui-calendar-panel">
                    <Calendar
                        events={events}
                        selectable={true}
                        onRangeChange={(e) => {this.onRangeChange(e)}}
                        activeModal={true}
                        modalFields={[{label:'Título', field:'titulo'},{label:'Visible para', field:'visibleNombre'},{label:'Tipo de Evento', field:'tipoEventoNombre'}, {label:'Comienzo', field:'comienzo'}, {label:'Fin', field:'fin'}, {label:'Descripción', field:'descripcion'}, {label:'Resuelta', field:'resuelta_label'}]}
                        messages={{next: '>', previous:'<'}}
                        components={
                            {
                                eventWrapper: ({ event, children }) => (
                                    <Fragment>
                                        <ContextMenuTrigger id={'event'}>
                                            <div
                                                onContextMenu={
                                                    e => {
                                                        this.setState({evento_id: event.id});
                                                        e.preventDefault();
                                                    }
                                                }
                                            >
                                                {children}
                                            </div>
                                        </ContextMenuTrigger>
                                    </Fragment>
                                )
                            }
                        }
                    />
                </div>

                <ContextMenu id={'event'}>
                    <MenuItem>
                        <Modal action="DETAIL" onSubmit={this.onSubmit} id={() => {return evento_id}}/>
                    </MenuItem>
                    <MenuItem>
                        <Modal action="EDIT" onSubmit={this.onSubmit} id={() => {return evento_id}}/>
                    </MenuItem>
                    <MenuItem>
                        <Modal action="DELETE" onSubmit={this.onSubmit} id={() => {return evento_id}}/>
                    </MenuItem>
                    <MenuItem>
                        <Modal action="RESOLVER" onSubmit={this.onSubmit} id={() => {return evento_id}}/>
                    </MenuItem>
                </ContextMenu>
             </div>
        );
    }
}

export default MiCalendario;



// WEBPACK FOOTER //
// ./src/views/Calendar/MiCalendario.js